import type { CSSProperties, ReactNode } from 'react';
import type { Tone } from './Badge';

export interface PageHeaderProps {
  title: string;
  /** One clause on what this screen controls. */
  description?: ReactNode;
  /** System state, never a greeting: "212 branches". */
  status?: ReactNode;
  statusTone?: Tone;
  /** Screen-level actions, end-aligned. */
  actions?: ReactNode;
  style?: CSSProperties;
}

/** The first block of every screen: what it is and whether it is healthy. */
export function PageHeader({ title, description, status, statusTone = 'ok', actions, style }: PageHeaderProps) {
  const statusClasses = ['fs-page-header__status'];
  if (statusTone !== 'ok') statusClasses.push(`fs-page-header__status--${statusTone}`);
  return (
    <div className="fs-page-header" style={style}>
      <div className="fs-page-header__main">
        <h1 className="fs-page-header__title">{title}</h1>
        {(status || description) && (
          <div className="fs-page-header__meta">
            {status && (
              <span className={statusClasses.join(' ')} role="status">
                <span className="fs-page-header__status-dot" aria-hidden="true" />
                {status}
              </span>
            )}
            {description && <span className="fs-page-header__description">{description}</span>}
          </div>
        )}
      </div>
      {actions && <div className="fs-page-header__actions">{actions}</div>}
    </div>
  );
}
